var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("403 - Access Denied")]),_c('p',[_vm._v("You do not have permission to access this page.")])])}]

export { render, staticRenderFns }